import React, { useEffect, useState } from 'react';
import { Percent, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { toast } from 'sonner';
import apiClient from '@/services/apiClient';

const isAdmin = () => { try { return ['Admin', 'Super Admin'].includes(JSON.parse(localStorage.getItem('user') || '{}').role); } catch { return false; } };

/** How far above its ordered qty a PO line may be received (one % for every section) — Admin edits it. */
export const OverReceiptSetting = () => {
  const [pct, setPct] = useState(null);
  const [edit, setEdit] = useState(null);
  useEffect(() => { apiClient.get('/po-receipts/settings').then((r) => setPct(r.data.over_receipt_pct)).catch(() => {}); }, []);
  const save = async () => {
    try {
      const r = await apiClient.put('/po-receipts/settings', { over_receipt_pct: Number(edit) });
      setPct(r.data.over_receipt_pct); setEdit(null);
      toast.success(`Over-receipt limit set to ${r.data.over_receipt_pct}%`);
    } catch (e) { toast.error(e.response?.data?.detail?.[0]?.msg || e.response?.data?.detail || 'Could not save'); }
  };
  if (pct === null) return null;
  if (edit !== null) {
    return (
      <div className="flex items-center gap-1" data-testid="over-receipt-edit">
        <Input type="number" min="0" max="100" step="0.5" value={edit} onChange={(e) => setEdit(e.target.value)} className="h-8 w-20 text-sm" data-testid="over-receipt-input" />
        <span className="text-xs text-gray-500">%</span>
        <Button size="sm" onClick={save} data-testid="over-receipt-save"><Check className="w-4 h-4" /></Button>
        <Button size="sm" variant="ghost" onClick={() => setEdit(null)}>Cancel</Button>
      </div>
    );
  }
  return (
    <Button variant="outline" size="sm" disabled={!isAdmin()} onClick={() => setEdit(String(pct))} data-testid="over-receipt-btn"
      title={isAdmin() ? 'Change the over-receipt limit' : 'Only Admin can change this'}>
      <Percent className="w-4 h-4 mr-1" />Over-receipt limit {pct}%
    </Button>
  );
};
